import React from 'react';

function Resume({ resumeData }) {
  if (!resumeData) {
    return null;
  }

  const { education } = resumeData;
  
  if (!education || education.length === 0) {
    return null;
  }

  return (
    <section id="resume">
      <div className="row education">
        <div className="three columns header-col">
          <h1><span className="ed-title">Education</span></h1>
        </div>
        <div className="nine columns main-col">
          {education.map((edu, index) => (
            <div key={index} className="row item">
              <div className="twelve columns">
                <h3 className="school-title">{edu.school}</h3>
                <p className="info">
                  {edu.degree} <span>•</span> <em className="date">{edu.graduated}</em>
                </p>
                {edu.description && <p>{edu.description}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Resume;